import {Modal, Table, Button, Descriptions, Row, Col, Image} from "antd";
import React, {useState} from "react";
import Lang from "@components/Lang/Lang";
import "./DetailOrder.less";
import InventoryQueryService from "@services/InventoryQuerySerivce";
import dayjs from "dayjs";
import {numberWithCommas, toFixedWithCommas} from "@utils/number-util";
import Locale from "@utils/locale";

let locale = Locale.current();

/**
 * 订单详情
 *
 * @author Shann <851188611@qq.com>
 */
const DetailOrder = props => {
    /**
     * 订单
     */
    const [order, setOrder] = useState({});

    /**
     * 商品
     */
    const [dataSource, setDataSource] = useState({});

    /**
     * 订单跟踪
     */
    const [trace, setTrace] = useState({});

    /**
     * 属性
     */
    const [isModalVisible, setIsModalVisible] = useState(false);

    /**
     * 表格栏目
     * @type {[{title, render: (function(*, *)), key: string}, {dataIndex: string, title}]}
     */
    const columns = [
        {
            title: Lang({id: "ShangPinXiangShu", default: "商品箱数"}),
            key: "buyerCode",
            width: "70%",
            render: (text, record) => {
                return <Row className="goods-info">
                    <Col className="cover">
                        <Image width={80} height={80} src={record.skuFileUrl}
                               fallback="data:image/png;base64,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"/>
                    </Col>
                    <Col span={16}>
                        <h2>{record.skuName}</h2>
                        <Row>
                            <Col className="info-item" span={12}><Lang id="ZhuangLiang">装量</Lang> {record.skuCapacity}{__getServerDictItem("unit_type." + record.skuUnit)}/{__getServerDictItem("prd_goods_out_box_unit." + record.spuOutBoxUnit) || '-'}</Col>
                            <Col className="info-item" span={12}><Lang id="CaiGouJia">采购价</Lang> {order.currencySymbol}{" "}{numberWithCommas(toFixedWithCommas(record.price, 2))}</Col>
                            <Col className="info-item" span={12}><Lang id="TiJi">体积</Lang> {toFixedWithCommas(record.skuOutBoxVolume, 3) || '-'}m³</Col>
                            <Col className="info-item" span={12}><Lang id="ShangPinBianHao">商品编号</Lang> {record.skuNo}</Col>
                        </Row>
                    </Col>
                </Row>
            }
        },
        {
            title: Lang({id: "XiangShu", default: "箱数"}),
            dataIndex: "deliveryQuantity",
            render: (text) => ("x " + text)
        },
    ];

    /**
     * 显示模态框
     */
    const showModal = () => {
        InventoryQueryService.queryPoDetail({poId: props.poId}).then((resp) => {
            setOrder(resp.header);
            setDataSource(resp.list.itemList);
            setTrace(resp.trace[0]);
            setIsModalVisible(true);
        })
    };

    /**
     * 隐藏模态框
     */
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    /**
     * 返回模板
     */
    return (
        <span className="DetailOrder">
            {/* 按钮 */}
            <Button type="link" style={{padidngLeft: 0}} onClick={showModal}>{props.poCode}</Button>
            {/* 模态框 */}
            <Modal className="DetailOrder__modal" width="70%" title={Lang({id: "DingDanXiangQing", default: "订单详情"})} footer={null} open={isModalVisible} onCancel={handleCancel}>
                {/* 主内容 */}
                <Descriptions column={2}>
                    <Descriptions.Item label={Lang({id: "DingDan", default: "订单"})}>
                        <span className="primary-text">{order.code}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label={Lang({id: "KeHuBianHao", default: "客户编号"})}>
                        <span className="primary-text">{order.buyerCode}</span>
                        <span className="secondary-text">{order.email}</span>
                        <span className="secondary-text">{order.mobile ? `+${order.telCode} ${order.mobile}` : ""}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label={Lang({id: "ShouHuoRen", default: "收货人"})}>
                        <span className="primary-text">{order.consigneeName} +{order.telCode} {order.consigneeMonde}</span>
                        <span className="secondary-text">{locale !== "zh" ? (
                            <span>{order.country}&nbsp;{order.consigneeAddress}&nbsp;{order.city}</span>
                        ) : (
                            <span>{order.country}&nbsp;{order.city}&nbsp;{order.consigneeAddress}</span>
                        )}</span>
                    </Descriptions.Item>
                </Descriptions>
                {/* 次内容 */}
                <div className="secondary-content">
                    <div className="info">
                        <div className="info-item">
                            <label className="label-text"><Lang id="XinYuJiDaoGangShiJian">新预计到港时间</Lang></label>
                            <span className="content-text">{dayjs(order.arrivalPortDate).format("YYYY-MM-DD")}</span>
                        </div>
                        <div className="info-item">
                            <label className="label-text"><Lang id="XiangShu">箱数</Lang></label>
                            <span className="content-text">{order.totalQuantity}</span>
                        </div>
                        <div className="info-item">
                            <label className="label-text"><Lang id="KuanShu">款数</Lang></label>
                            <span className="content-text">{order.itemCount}</span>
                        </div>
                        <div className="info-item">
                            <label className="label-text"><Lang id="TiJi">体积</Lang></label>
                            <span className="content-text">{toFixedWithCommas(order.totalVolume, 3) || "-"}{" "}m³</span>
                        </div>
                    </div>
                    <p className="info-log">{dayjs(trace.trackTime).format("YYYY-MM-DD")} {trace.trackDesc}</p>
                    <div className="money">
                        <div className="money-item">
                            <label className="label-text"><Lang id="DingDan">订单</Lang></label>
                            <span className="content-text">{order.currencySymbol}{" "}{numberWithCommas(toFixedWithCommas(order.totalPrice, 2) || 0) || "-"}</span>
                        </div>
                        <div className="money-item">
                            <label className="label-text"><Lang id="DingJin">定金</Lang></label>
                            <span className="content-text">{order.currencySymbol}{" "}{numberWithCommas(toFixedWithCommas(order.needDepositMoney, 2) || 0) || "-"}</span>
                        </div>
                        <div className="money-item">
                            <label className="label-text"><Lang id="WeiKuan">尾款</Lang></label>
                            <span className="content-text">{order.currencySymbol}{" "}{numberWithCommas(toFixedWithCommas(order.remainingPayment, 2) || 0) || "-"}</span>
                        </div>
                    </div>
                </div>
                {/* 数据列表 */}
                <Table dataSource={dataSource} columns={columns} rowKey="id" pagination={false}/>
                {/* 底部信息 */}
                <div className="footer-info mt_16"><Lang id="HeJi">合计</Lang>：{order.itemCount}<Lang id="Kuan">款</Lang>，{order.totalQuantity}<Lang id="Xiang">箱</Lang></div>
            </Modal>
        </span>
    );
}

export default DetailOrder;

